import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import usePageMeta from "../../utils/usePageMeta";

const Contact = () => {
  usePageMeta({
    title: "Contact MD Wedding Props | Get in Touch",
    description:
      "Contact MD Wedding Props for availability, pricing, and custom decor requests.",
    keywords: "contact wedding props, wedding decor inquiry, custom wedding props",
  });

  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState("");
  useEffect(() => {
    setPrevLocation(location.state ? location.state.data : "");
  }, [location]);

  const [clientName, setclientName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [messages, setMessages] = useState("");

  // ========== Error Messages Start here ============
  const [errClientName, setErrClientName] = useState("");
  const [errContactNumber, setErrContactNumber] = useState("");
  const [errMessages, setErrMessages] = useState("");
  // ========== Error Messages End here ==============
  const [successMsg, setSuccessMsg] = useState("");

  const handleName = (e) => {
    setclientName(e.target.value);
    setErrClientName("");
  };
  const handleContactNumber = (e) => {
    setContactNumber(e.target.value);
    setErrContactNumber("");
  };
  const handleMessages = (e) => {
    setMessages(e.target.value);
    setErrMessages("");
  };

  // ================= Contact Number Validation start here =============
  const ContactNumberValidation = (number) => {
    return String(number).match(/^[0-9]{10}$/);
  };
  // ================= Contact Number Validation End here ===============

  const handlePost = (e) => {
    e.preventDefault();
    if (!clientName) {
      setErrClientName("Enter your Name");
    }
    if (!contactNumber) {
      setErrContactNumber("Enter your Contact Number");
    } else {
      if (!ContactNumberValidation(contactNumber)) {
        setErrContactNumber("Enter a Valid Contact Number (10 digits)");
      }
    }
    if (!messages) {
      setErrMessages("Enter your Messages");
    }
    if (clientName && contactNumber && ContactNumberValidation(contactNumber) && messages) {
      setSuccessMsg(
        `Thank you dear ${clientName}, Your message has been received successfully. We will contact you at ${contactNumber}.`
      );

      // Construct WhatsApp URL and open in a new tab
      const whatsappUrl = `https://wa.me/919927942278?text=${encodeURIComponent(
        `Name: ${clientName}\nContact Number: ${contactNumber}\nMessage: ${messages}`
      )}`;
      window.open(whatsappUrl, "_blank");
    }
  };

  return (
    <div className="max-w-container mx-auto px-4">
      <Breadcrumbs title="Contact" prevLocation={prevLocation} />
      {successMsg ? (
        <p className="pb-20 w-96 font-medium text-green-500">{successMsg}</p>
      ) : (
        <form className="pb-20">
          <h1 className="font-titleFont font-semibold text-3xl">
            Fill up a Form
          </h1>
          <div className="w-[500px] h-auto py-6 flex flex-col gap-6">
            <div>
              <p className="text-base font-titleFont font-semibold px-2">
                Name
              </p>
              <input
                onChange={handleName}
                value={clientName}
                className="w-full py-1 border-b-2 px-2 text-base font-medium placeholder:font-normal placeholder:text-sm outline-none focus-within:border-primeColor"
                type="text"
                placeholder="Enter your name here"
              />
              {errClientName && (
                <p className="text-red-500 text-sm font-titleFont font-semibold mt-1 px-2 flex items-center gap-1">
                  <span className="text-sm italic font-bold">!</span>
                  {errClientName}
                </p>
              )}
            </div>
            <div>
              <p className="text-base font-titleFont font-semibold px-2">
                Contact Number
              </p>
              <input
                onChange={handleContactNumber}
                value={contactNumber}
                className="w-full py-1 border-b-2 px-2 text-base font-medium placeholder:font-normal placeholder:text-sm outline-none focus-within:border-primeColor"
                type="text"
                placeholder="Enter your contact number here"
              />
              {errContactNumber && (
                <p className="text-red-500 text-sm font-titleFont font-semibold mt-1 px-2 flex items-center gap-1">
                  <span className="text-sm italic font-bold">!</span>
                  {errContactNumber}
                </p>
              )}
            </div>
            <div>
              <p className="text-base font-titleFont font-semibold px-2">
                Messages
              </p>
              <textarea
                onChange={handleMessages}
                value={messages}
                cols="30"
                rows="3"
                className="w-full py-1 border-b-2 px-2 text-base font-medium placeholder:font-normal placeholder:text-sm outline-none focus-within:border-primeColor resize-none"
                type="text"
                placeholder="Enter your message here"
              ></textarea>
              {errMessages && (
                <p className="text-red-500 text-sm font-titleFont font-semibold mt-1 px-2 flex items-center gap-1">
                  <span className="text-sm italic font-bold">!</span>
                  {errMessages}
                </p>
              )}
            </div>
            <button
              onClick={handlePost}
              className="w-44 bg-primeColor text-gray-200 h-10 font-titleFont text-base tracking-wide font-semibold hover:bg-black hover:text-white duration-200"
            >
              Post
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Contact;
